import React from "react";
import { UserProviders } from "@/entities";

interface Props {
  defaultValue: any;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLSelectElement>) => void;
  value: string;
}
export function UserProvierSelect({
  defaultValue,
  onChange,
  onBlur,
  value,
}: Props) {
  return (
    <select
      className="form-select"
      onChange={onChange}
      onBlur={onBlur}
      value={value}
    >
      <option value={defaultValue.key}>{defaultValue.value}</option>
      {UserProviders?.map((item, index) => {
        return (
          <option key={index} value={item.key}>
            {item.value}
          </option>
        );
      })}
    </select>
  );
}
